export default __webpack_public_path__ + "static/media/teli.f3b03529.jpg";